function validate() {
  const name = this.$route.params.id
    ? this.games.filter(name => name.name == this.gameById.name)
    : this.games.filter(name => name.name == this.select.name)
  name.forEach(element => {
    this.game_id = element.game_id
  })
  if (this.rcaptcha !== '') {
    this.$refs.form.validate()
  } else {
    this.recaptchaAlert = true
  }

  if (this.$refs.form.validate() && this.rcaptcha !== '') {
    this.action_save_user()

    if (this.$refs.code) {
      this.$refs.code.reset()
    }

    if (!this.$route.params.id && this.$refs.code_game) {
      this.$refs.code_game.reset()
    }
  } else {
    this.$store.commit(
      'MESSAGE_ERROR',
      'Vui lòng nhập thông tin để hoàn thành nhận giftcode.',
      { root: true }
    )
  }
}

export { validate }
